import { render, staticRenderFns } from "./W3CUKeyConfigEditor.vue?vue&type=template&id=3280d163&scoped=true&"
import script from "./W3CUKeyConfigEditor.vue?vue&type=script&lang=js&"
export * from "./W3CUKeyConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280d163",
  null
  
)

export default component.exports